import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Organization } from "shared/types/Organization";
import {
  User,
  UserCompanyType,
  UserOrganization,
  UserOrganizationPermissionGroup,
} from "shared/types/User";
import textService from "@/services/textService";
import OrganizationTabUsersItem from "@/views/organizations/components/OrganizationTabUsersItem.vue";
import { calculateIndentation } from "@/views/organizations/organizations";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTabUsersList',
  props: {
    users: {},
    organization: {},
    hideNoUsersMessage: { type: Boolean },
    canEdit: { type: Boolean },
    indentation: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

const organizationByUsers = computed(() =>
  props.users.reduce((acc, user) => {
    acc[user._id] = user.organizations.find(
      (organization) => organization.organization_id === props.organization._id,
    );
    return acc;
  }, {} as Record<string, UserOrganization | undefined>),
);

const groupWeight: Record<UserOrganizationPermissionGroup, number> = {
  organization_base: 0,
  organization_admin: 100,
};

const getGroupWeight = (groups?: UserOrganizationPermissionGroup[]) =>
  (groups || []).map((group) => groupWeight[group] || 0).reduce((acc, item) => acc + item, 0);

const sortedUsers = computed(() =>
  props.users.slice().sort((a, b) => {
    const organizationA = organizationByUsers.value[a._id];
    const organizationB = organizationByUsers.value[b._id];

    const companyTypeA = organizationA?.company_type || "";
    const companyTypeB = organizationB?.company_type || "";

    const groupsA = getGroupWeight(organizationA?.groups);
    const groupsB = getGroupWeight(organizationB?.groups);

    const userRoleA = a.role || "";
    const userRoleB = b.role || "";

    if (companyTypeA === companyTypeB) {
      if (groupsA === groupsB) {
        return textService.localeCompareWithEmptyStringAtEnd(userRoleA, userRoleB);
      }
      return groupsB - groupsA;
    }
    return textService.localeCompareWithEmptyStringAtEnd(companyTypeA, companyTypeB);
  }),
);

const companyTypes = computed(
  () =>
    new Set<UserCompanyType>(
      props.users
        .map((user) => organizationByUsers.value[user._id]?.company_type)
        .filter((item) => item) as UserCompanyType[],
    ),
);

const getShouldShowCompanyTypeBadge = (user: User, index: number) => {
  if (companyTypes.value.size < 2) {
    return false;
  }
  const previousUser = sortedUsers.value[index - 1];
  if (!previousUser) {
    return true;
  }
  const userCompanyType = organizationByUsers.value[user._id]?.company_type ?? null;
  const previousUserCompanyType = organizationByUsers.value[previousUser._id]?.company_type ?? null;
  return userCompanyType !== previousUserCompanyType;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.users.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedUsers.value, (user, index) => {
            return (_openBlock(), _createBlock(OrganizationTabUsersItem, {
              key: user._id,
              user: user,
              organization: _ctx.organization,
              canEdit: _ctx.canEdit,
              showCompanyTypeBadge: getShouldShowCompanyTypeBadge(user, index),
              indentation: _ctx.indentation,
              cls: index === sortedUsers.value.length - 1 ? '' : 'border-b'
            }, null, 8, ["user", "organization", "canEdit", "showCompanyTypeBadge", "indentation", "cls"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideNoUsersMessage && sortedUsers.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "px-2 py-2 truncate text-gray-400 text-xs",
          style: _normalizeStyle({ paddingLeft: `${_unref(calculateIndentation)(_ctx.indentation)}px` })
        }, _toDisplayString(_unref(t)("organizations.no_users")), 5))
      : _createCommentVNode("", true)
  ], 64))
}
}

})